import CustomersService from '../service/CustomersService';
import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Toolbar } from 'primereact/toolbar';
import { InputSwitch } from 'primereact/inputswitch';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressBar } from 'primereact/progressbar';
import { Chips } from 'primereact/chips';
import csvheader from './csvheader.json'


import 'primeicons/primeicons.css';

import './Customers.css';
import { Auth } from 'aws-amplify';

const Customers = () => {

  let emptyFormaValidationState = {
    primaryEmail: "",
    secondaryEmail: [],
    customerNr: "",
    organization: "",
    company: "",
    company2: [],
    country: "",
    language: "",
    telephone: [],
    firstName: "",
    surName: "",
    valid: true
  }

  let emptyCustomer = {
    customerId: "",
    primaryEmail: "",
    secondaryEmail: [],
    customerNr: "",
    organization: "",
    company: "",
    company2: [],
    country: "",
    language: "",
    telephone: [],
    firstName: "",
    surName: "",
    pkwData: 0,
    lkwData: 0,
    valid: 0,
  };

  // eslint-disable-next-line no-control-regex, no-useless-escape
  const emailRegex = /^((([a-zA-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-z]|\d|-||_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+|(([a-zA-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+([a-zA-z]+|\d|-|\.{0,1}|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])?([a-zA-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/;
  // const alphaNumericRegex = /[a-zA-Z0-9\-_\x7f-\xff]/
  const alphaNumericRegex = /[a-zA-Z0-9\-_]/

  const customersService = new CustomersService()

  const [customers, setCustomers] = useState([]);
  const [customerDialog, setCustomerDialog] = useState(false);
  const [deleteCustomerDialog, setDeleteCustomerDialog] = useState(false);
  const [deleteCustomersDialog, setDeleteCustomersDialog] = useState(false);
  const [customer, setCustomer] = useState(emptyCustomer);
  const [selectedCustomers, setSelectedCustomers] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [progressBar, setProgressBar] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progressHeader, setProgressHeader] = useState("");
  const [progressBarMax, setProgressBarMax] = useState(0);
  const [currentOrganization, setCurrentOrganization] = useState("")
  const [formValidationState, setFormValidationState] = useState(emptyFormaValidationState)
  const [isAdmin, setIsAdmin] = useState(false)
  const toast = useRef(null);
  const dt = useRef(null);
  const fileRef = useRef(null);

  useEffect(() => {
    Auth.currentSession().then((res) => {
      const groups = res.idToken.payload["cognito:groups"]
      const org = res.idToken.payload["custom:organization"]
      setCurrentOrganization(org)
      if (groups.includes("GS-ADMIN")) {
        setIsAdmin(true)
        loadAllCustomers();
      } else {
        loadCustomers();
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
  }, [formValidationState])

  useEffect(() => {
  }, [customer])

  const openNew = () => {
    setCustomer(emptyCustomer);
    setCustomerDialog(true);
  }

  const hideDialog = () => {
    setCustomerDialog(false);
  }

  const showProgressBar = () => {
    setProgress(0);
    setProgressBar(true)
  }

  const hideProgressBar = () => {
    setProgressBar(false)
  }

  const hideDeleteCustomerDialog = () => {
    setDeleteCustomerDialog(false);
  }

  const hideDeleteCustomersDialog = () => {
    setDeleteCustomersDialog(false);
  }

  function validateCustomer(customer) {

    customer.valid = true;
    setFormValidationState(emptyFormaValidationState);

    if (validateCustomerNr(customer.customerNr)) {
      customer.valid = false
    }

    if (validatePrimaryEmail(customer)) {
      customer.valid = false
    }

    if (validateSecondaryEmail(customer).length > 0) {
      customer.valid = false
    }

    if (validateCompany(customer.company)) {
      customer.valid = false
    }

    if (validateCompany2(customer.company2).length > 0) {
      customer.valid = false
    }

    if (validateCountry(customer.country)) {
      customer.valid = false
    }

    if (validateLanguage(customer.language)) {
      customer.valid = false
    }

    if (validateTelephone(customer.telephone).length > 0) {
      customer.valid = false
    }

    if (validateFirstName(customer.firstName)) {
      customer.valid = false
    }

    if (validateSurName(customer.surName)) {
      customer.valid = false
    }

    return customer.valid;
  }

  const validateCountry = (country) => {
    const countryRegex = /^A[^ABCHJKNPVY ]|B[^CKPUX ]|C[^BEJPQST ]|D[EJKMOZ]|E[CEGHRST]|F[IJKMOR]|G[^CJKOVXZ ]|H[KMNRTU]|I[DEL-OQ-T]|J[EMOP]|K[EGHIMNPRWYZ]|L[ABCIKR-VY]|M[^BIJ ]|N[ACEFGILOPRUZ ]|OM|P[AE-HK-NRSTWY]|QA|R[EOSUW]|S[^FPQUW ]|T[^ABEIPQSUXY ]|U[AGMSYZ]|V[ACEGINU]|WF|WS|YE|YT|Z[AMW]$/;
    let errorMessage = "";
    if (!countryRegex.test(country)) {
      errorMessage = "Country format invalid! (AA)"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    }
    setFormValidationState((formValidationState) => ({ ...formValidationState, country: errorMessage }))
    return errorMessage;
  }

  const validateCustomerNr = (customerNr) => {
    let errorMessage = "";
    if (!customerNr.trim()) {
      errorMessage = "CustomerNr is required!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    } else if (customerNr.length > 50) {
      errorMessage = "CustomerNr must have max. 50 characters!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    } else if (!alphaNumericRegex.test(customerNr)) {
      errorMessage = "CustomerNr must be alphanumeric!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    }
    setFormValidationState((formValidationState) => ({ ...formValidationState, customerNr: errorMessage }))
    return errorMessage;
  }

  const validatePrimaryEmail = (_customer) => {
    let errorMessage = "";
    if (!emailRegex.test(_customer.primaryEmail)) {
      errorMessage = "Email format invalid!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    } else {
      errorMessage = checkDuplicates(_customer.primaryEmail, _customer).toString()
    }
    setFormValidationState((formValidationState) => ({ ...formValidationState, primaryEmail: errorMessage }))
    return errorMessage;
  }

  const validateSecondaryEmail = (_customer) => {
    let errors = [];
    const emails = _customer.secondaryEmail
    for (var i = 0; i < emails.length; i++) {
      let errorMessage = ""
      if (!emailRegex.test(emails[i])) {
        errorMessage = "Email format invalid! ";
        errors.push(errorMessage + " (" + emails[i] + ")")
        setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
      } else {
        errors = [...checkDuplicates(emails[i], _customer)];
      }
    }
    if (errors.length > 0) {
      setFormValidationState((formValidationState) => ({ ...formValidationState, secondaryEmail: errors }))
    }
    return errors;
  }

  const checkDuplicates = (email, _customer) => {
    let errorMessage = "";
    let errors = []
    let index = findDuplicateEmailInPrimaryEmails(email, _customer);
    if (index >= 0) {
      errorMessage = `"Email is possible duplicate of customer: ${customers[index].customerNr} (${customers[index].primaryEmail})"`;
      errors.push(errorMessage + " (" + email + ")")
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }));
    } else {
      index = findDuplicateEmailInSecondaryEmails(email, _customer);
      if (index >= 0 && customers[index].customerNr !== _customer.customerNr) {
        errorMessage = `"Email is possible duplicate of customer: ${customers[index].customerNr} (${customers[index].secondaryEmail})"`;
        errors.push(errorMessage + " (" + email + ")")
        setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }));
      }
    }
    return errors;
  }

  const validateCompany = (company) => {
    let errorMessage = "";
    if (!company.trim()) {
      errorMessage = "Company is required!";
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    } else if (company.length > 50) {
      errorMessage = "CustomerNr must have max. 50 characters!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    } else if (!alphaNumericRegex.test(company)) {
      errorMessage = "Company must be alphanumeric!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    }
    setFormValidationState((formValidationState) => ({ ...formValidationState, company: errorMessage }))
    return errorMessage;
  }

  const validateCompany2 = (value) => {
    let errors = [];
    for (var i = 0; i < value.length; i++) {

      let errorMessage = "";
      if (value[i].length > 50) {
        errorMessage = "Company must have max. 50 characters!"
        setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
        errors.push(errorMessage + " (" + value[i] + ")")
      } else if (!alphaNumericRegex.test(value[i])) {
        errorMessage = "Company2 must be alphanumeric!"
        setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
        errors.push(errorMessage + " (" + value[i] + ")")
      }
    }
    if (errors.length > 0) {
      setFormValidationState((formValidationState) => ({ ...formValidationState, company2: errors }))
    }
    return errors;
  }

  const validateLanguage = (language) => {
    let errorMessage = "";
    const languageRegex = /^[a-z]{2}$/;
    if (!languageRegex.test(language)) {
      errorMessage = "Language format invalid! (aa)"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    }
    setFormValidationState((formValidationState) => ({ ...formValidationState, language: errorMessage }))
    return errorMessage;
  }

  const validateTelephone = (telephone) => {
    let errors = [];
    for (var i = 0; i < telephone.length; i++) {
      const errorMessage = validatePhoneNumber(telephone[i])
      if (errorMessage) {
        errors.push(errorMessage)
        setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
      }
    }
    if (errors.length > 0) {
      setFormValidationState((formValidationState) => ({ ...formValidationState, telephone: errors }))
    }
    return errors;
  }

  const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^\+[0-9]{6,15}$/;
    if (!phoneRegex.test(phoneNumber)) {
      return `"Telephone format invalid: ${phoneNumber} "`;
    }
    return "";
  }

  const validateFirstName = (firstName) => {
    let errorMessage = "";
    if (firstName.length > 30) {
      errorMessage = "Firstname must have max. 30 characters!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    } else if (firstName && !alphaNumericRegex.test(firstName)) {
      errorMessage = "Firstname must be alphanumeric!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    }
    setFormValidationState((formValidationState) => ({ ...formValidationState, firstName: errorMessage }))
    return errorMessage;
  }

  const validateSurName = (surName) => {
    let errorMessage = "";
    if (!surName.trim()) {
      errorMessage = "Surname is required!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    } else if (surName.length > 50) {
      errorMessage = "Surname must have max. 30 characters!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    } else if (!alphaNumericRegex.test(surName)) {
      errorMessage = "Surname must be alphanumeric!"
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    }
    setFormValidationState((formValidationState) => ({ ...formValidationState, surName: errorMessage }))
    return errorMessage;
  }

  async function saveCustomer() {

    if (validateCustomer(customer)) {

      let _customers = [...customers];
      let _customer = { ...customer };

      // update
      if (customer.customerId) {

        const updateCustomerInput = {
          primaryEmail: _customer.primaryEmail,
          secondaryEmail: _customer.secondaryEmail,
          customerNr: _customer.customerNr,
          company: _customer.company,
          company2: _customer.company2,
          country: _customer.country,
          language: _customer.language,
          telephone: _customer.telephone,
          firstName: _customer.firstName,
          surName: _customer.surName,
          pkwData: _customer.pkwData,
          lkwData: _customer.lkwData
        }
        try {
          const result = await customersService.updateCustomer({ customerId: customer.customerId, customer: updateCustomerInput })
          const updatedCustomer = { ...result.data.updateCustomer, valid: true }
          const index = findIndexById(customer.customerId);
          _customers[index] = updatedCustomer;
          toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Customer Updated', life: 3000 });
        } catch (error) {
          console.log(error)
          toast.current.show({ severity: 'error', summary: 'Error', detail: 'Customer Update Failed', life: 3000 });
        }

      }
      // create new customer
      else {

        const createCustomerInput = {
          primaryEmail: _customer.primaryEmail,
          secondaryEmail: _customer.secondaryEmail,
          customerNr: _customer.customerNr,
          company: _customer.company,
          company2: _customer.company2,
          country: _customer.country,
          language: _customer.language,
          telephone: _customer.telephone,
          firstName: _customer.firstName,
          surName: _customer.surName,
          pkwData: _customer.pkwData,
          lkwData: _customer.lkwData
        }
        try {
          const result = await customersService.createCustomer({ customer: createCustomerInput })
          const newCustomer = {
            ...result.data.createCustomer,
            valid: true
          }
          _customers.push(newCustomer);
          toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Customer Created', life: 3000 });
        } catch (error) {
          console.log(error)
          toast.current.show({ severity: 'error', summary: 'Error', detail: 'Customer Creation Failed', life: 3000 });
        }
      }

      setCustomers(_customers);
      setCustomerDialog(false);
      setCustomer(emptyCustomer);
    }
  }

  const editCustomer = (customer) => {
    setCustomer({ ...customer });
    validateCustomer(customer)
    setCustomerDialog(true);
  }

  const confirmDeleteCustomer = (customer) => {
    setCustomer(customer);
    setDeleteCustomerDialog(true);
  }

  async function deleteCustomer() {
    let _customers = customers.filter(val => val.customerId !== customer.customerId);
    try {
      if (isAdmin) {
        await customersService.adminDeleteCustomer({ customerId: customer.customerId });
      } else {
        await customersService.deleteCustomer({ customerId: customer.customerId });
      }
      setCustomers(_customers);
      setDeleteCustomerDialog(false);
      setCustomer(emptyCustomer);
      const detail = "Customer Deleted: " + customer.customerNr
      toast.current.show({ severity: 'success', summary: 'Successful', detail, life: 3000 });
    } catch (error) {
      console.log(error)
      const detail = "Customer Deletion failed: " + customer.customerNr
      toast.current.show({ severity: 'error', summary: 'Error', detail, life: 3000 });
    }
  }

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < customers.length; i++) {
      if (customers[i].customerId === id) {
        index = i;
        break;
      }
    }

    return index;
  }

  const getAsArray = (s) => {
    let array = [];
    if (s) {
      array = s.split(',')
    }
    return array;
  }

  const importCSV = (e) => {

    let file = e.files[0];
    let reader = new FileReader();
    try {
      reader.onload = async (e) => {
        const csv = e.target.result;
        const data = csv.split('\n');
        // Prepare DataTable, some seem to export ',,/r' at line-ends, they must be removed, more specials likely to follow
        const originalColumnNames = data[0].split(';');
        // normalized ColumnNames
        const cols = data[0].replaceAll(/['"]+/g, '').replaceAll(',,\r', '').replaceAll(' ', '').replaceAll('\r', '').split(';');
        for (var i = 0; i < cols.length; i++) {
          const columnName = csvheader[cols[i]];
          if (!columnName) {
            hideProgressBar();
            toast.current.show({ severity: 'error', summary: 'Error', detail: `Error in input format!\n Unknown column name '${originalColumnNames[i]}'`, life: 6000 });
            return false;
          }
          cols[i] = columnName;
        }
        data.shift();
        const filteredData = data.filter((el) => {
          if (el.length === 0) {
            return false;
          }
          const fieldcount = el.split(";").length;
          if (fieldcount !== 13) {
            console.log(`expected 13 fields, but received ${fieldcount}! data: "${el}"`)
            toast.current.show({ severity: 'error', summary: 'Error', detail: `Some lines could not be imported! see log for details`, life: 6000 });
            return false;
          }
          return true;
        })

        const importedData = filteredData.map(d => {
          console.log("d", `"${d}"`)
          d = d.split(';');

          const processedData = cols.reduce((obj, c, i) => {
            obj[c] = d[i].replaceAll(/['"]+/g, '').replaceAll(',,\r', '').replaceAll('\r', '');
            (c === 'pkwData' || c === 'lkwData') && (obj[c] = Boolean(Number((obj[c]))));
            (c === 'secondaryEmail' || c === 'company2' || c === 'telephone') && (obj[c] = getAsArray(obj[c]));
            return obj;
          }, {});

          return processedData;

        });

        showProgressBar();
        setProgressBarMax(importedData.length);
        for (var j = 0; j < importedData.length; j++) {
          const _progress = Math.round(((j + 1) / importedData.length) * 100)
          setProgress(_progress);
          setProgressHeader("importing customer " + (j + 1) + " / " + importedData.length)
          await customersService.createCustomer({ customer: importedData[j] })
        }
        hideProgressBar();

        loadCustomers();
      };
      reader.readAsText(file, 'UTF-8');
    } catch (error) {
      console.log(error)
      toast.current.show({ severity: 'error', summary: 'Error', detail: `Error in input format! see log for details`, life: 6000 });
    } finally {
      e.options.clear();
      hideProgressBar();
    }
  }

  const loadCustomers = () => {
    customersService.listMyCustomers({ limit: 5000, nextToken: null }).then(result => {
      const customers = result.data.listMyCustomers.customers
      let _customers = []
      for (var i = 0; i < customers.length; i++) {
        let _customer = customers[i]
        const isValid = validateCustomer(_customer)
        _customer.valid = isValid
        _customers.push(_customer)
      }
      setCustomers(_customers)
    });
  };

  const loadAllCustomers = () => {
    customersService.listAllCustomers({ limit: 5000, nextToken: null }).then(result => {
      const customers = result.data.listAllCustomers.customers
      let _customers = []
      for (var i = 0; i < customers.length; i++) {
        let _customer = customers[i]
        const isValid = validateCustomer(_customer)
        _customer.valid = isValid
        _customers.push(_customer)
      }
      setCustomers(_customers)
    });
  };

  const exportCSV = () => {
    const responseStructure = [
      { columnName: 'primaryEmail', displayName: 'PrimaryEmail' },
      { columnName: 'secondaryEmail', displayName: 'Secondary' },
      { columnName: 'customerNr', displayName: 'CustomerNr' },
      { columnName: 'organization', displayName: 'Organization' },
      { columnName: 'company', displayName: 'Company' },
      { columnName: 'company2', displayName: 'Company2' },
      { columnName: 'country', displayName: 'Country' },
      { columnName: 'language', displayName: 'Language' },
      { columnName: 'telephone', displayName: 'Telephone' },
      { columnName: 'firstName', displayName: 'FirstName' },
      { columnName: 'surName', displayName: 'Surname' },
      { columnName: 'pkwData', displayName: 'PKWData' },
      { columnName: 'lkwData', displayName: 'LKWData' }
    ];

    const csvSeparator = dt.current.props.csvSeparator;

    const filteredRows = filterRows();
    // Transform data into CSV
    const header = responseStructure.map(field => field.displayName).join(csvSeparator);
    const data = filteredRows.map(row => {
      const rowData = responseStructure.map(field => {
        if (field.columnName === 'telephone') {
          let telephone = row[field.columnName];
          if (Array.isArray(telephone)) {
            telephone = telephone.join(',');
          }
          return `${telephone}`;
        }
        if (field.columnName === 'pkwData' || field.columnName === 'lkwData') {
          return row[field.columnName] ? 1 : 0;
        }
        return row[field.columnName];
      }).join(csvSeparator);
      return rowData;
    }).join('\n');
    const csvData = `${header}\n${data}`.replace(/\n/g, '\r\n');

    // Download CSV file
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'download.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const filterRows = () => {
    return dt.current.props.value.filter(row => {
      if (!globalFilter) return true;
      const regex = new RegExp(globalFilter, 'i');
      return Object.values(row).some(val => regex.test(val));
    });
  }
  const confirmDeleteSelected = () => {
    setDeleteCustomersDialog(true);
  }

  const deleteSelectedCustomers = () => {
    // the remaining customers
    let _customers = customers.filter(val => !selectedCustomers.includes(val));
    // the customers to be deleted
    let _deleteCustomers = customers.filter(val => selectedCustomers.includes(val)).map(val =>
      ({ customerId: val.customerId, owner: val.owner })
    );
    try {
      for (var i = 0; i < _deleteCustomers.length; i++) {
        if (isAdmin) {
          customersService.adminDeleteCustomer({ customerId: _deleteCustomers[i].customerId, owner: _deleteCustomers[i].owner });
        } else {
          customersService.deleteCustomer({ customerId: _deleteCustomers[i].customerId });
        }
      }
      setCustomers(_customers);
      setDeleteCustomersDialog(false);
      setSelectedCustomers(null);
      toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Customers Deleted', life: 3000 });
    } catch (error) {
      console.log(error)
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error deleting customer', life: 3000 });
    }
  }

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || '';
    let _customer = { ...customer };
    _customer[`${name}`] = val;
    setCustomer(_customer);
  }

  const onInputBooleanChange = (e, name) => {
    const val = (e.target && e.target.value) || false;
    let _customer = { ...customer };
    _customer[`${name}`] = val;

    setCustomer(_customer);
  }

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={confirmDeleteSelected} disabled={!selectedCustomers || !selectedCustomers.length} />
      </React.Fragment>
    )
  }

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <FileUpload name="data" ref={fileRef} accept="text/csv" customUpload={true} uploadHandler={importCSV} mode="basic" auto={true} chooseLabel="Upload CSV" />
        <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
      </React.Fragment>
    )
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-outlined p-button-success mr-2" onClick={() => editCustomer(rowData)} />
        <Button icon="pi pi-trash" className="p-button-rounded p-button-outlined p-button-warning" onClick={() => confirmDeleteCustomer(rowData)} />
      </React.Fragment>
    );
  }

  const booleanBodyTemplate = (rowData, item) => {
    const isEnabled = rowData[item.field]
    if (isEnabled) {
      return (
        <React.Fragment>
          <i className="pi pi-check"></i>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <i className="pi pi-times"></i>
        </React.Fragment>
      )
    }
  };

  const validationBodyTemplate = (rowData, item) => {
    const isEnabled = rowData[item.field]
    if (isEnabled) {
      return (
        <React.Fragment>
          <i className="pi pi-check"></i>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <i className="pi pi-times"></i>
        </React.Fragment>
      )
    }
  };

  const listBodyTemplate = (rowData, item) => {
    return (
      <React.Fragment>
        <ol>
          {rowData[item.field].map(el => (
            <li style={{ listStyle: "none" }} key={el}>{el}</li>
          ))}
        </ol>
      </React.Fragment>
    )
  }

  const header = (
    <div className="table-header">
      <h5 className="mx-0 my-1">Customers of {currentOrganization}</h5>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </span>
    </div>
  );

  const customerDialogFooter = (
    <React.Fragment>
      <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
      <Button label="Save" icon="pi pi-check" className="p-button-text" onClick={saveCustomer} />
    </React.Fragment>
  );

  const deleteCustomerDialogFooter = (
    <React.Fragment>
      <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteCustomerDialog} />
      <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteCustomer} />
    </React.Fragment>
  );

  const deleteCustomersDialogFooter = (
    <React.Fragment>
      <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteCustomersDialog} />
      <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteSelectedCustomers} />
    </React.Fragment>
  );

  const onSecondaryEmailRemove = (e) => {
    const email = e[0];
    const index = formValidationState.secondaryEmail.findIndex(item => item.toString().includes(email));
    if (index >= 0) {
      let _errors = [...formValidationState.secondaryEmail]
      _errors.splice(index, 1)
      setFormValidationState((formValidationState) => ({ ...formValidationState, secondaryEmail: _errors }))
    }
  }

  const findDuplicateEmailInPrimaryEmails = (email, _customer) => {
    let index = -1;
    index = customers.findIndex(item => (item.primaryEmail === email) && (item.customerNr !== _customer.customerNr))
    return index;
  }

  const findDuplicateEmailInSecondaryEmails = (email, _customer) => {
    let index = -1;
    index = customers.findIndex(item => item.secondaryEmail.includes(email) && item.customerNr !== _customer.customerNr)
    return index;
  }

  const onSecondaryEmailAdd = (e, _customer) => {
    let errorMessage = "";
    let errors = []
    const email = e.value
    if (!emailRegex.test(email)) {
      errorMessage = "Email format invalid: " + email;
      errors.push(errorMessage)
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    } else {
      errors = [...checkDuplicates(email, _customer)]
    }
    if (errors.length > 0) {
      setFormValidationState((formValidationState) => ({ ...formValidationState, secondaryEmail: [...formValidationState.secondaryEmail, errors] }))
    }
  }

  const onCompany2Add = (e) => {
    let errorMessage = "";
    let errors = []
    const company2 = e.value;
    if (company2.length > 50) {
      errorMessage = "Company must have max. 50 characters: " + company2
      errors.push(errorMessage)
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    }
    if (errors.length > 0) {
      setFormValidationState((formValidationState) => ({ ...formValidationState, company2: [...formValidationState.company2, errors] }))
    }
  }

  const onCompany2Remove = (e) => {
    const company2 = e.value[0];
    const index = formValidationState.company2.findIndex(item => item.toString().includes(company2));
    if (index >= 0) {
      let _errors = [...formValidationState.company2]
      _errors.splice(index, 1)
      setFormValidationState((formValidationState) => ({ ...formValidationState, company2: _errors }))
    }
  }

  const onTelephoneAdd = (e) => {
    let errorMessage = "";
    let errors = []
    const telephone = e.value;
    errorMessage = validatePhoneNumber(telephone);
    if (errorMessage) {
      errors.push(errorMessage)
      setFormValidationState((formValidationState) => ({ ...formValidationState, valid: false }))
    }
    if (errors.length > 0) {
      setFormValidationState((formValidationState) => ({ ...formValidationState, telephone: [...formValidationState.telephone, errors] }))
    }
  }

  const onTelephoneRemove = (e) => {
    const telephone = e.value[0];
    const index = formValidationState.telephone.findIndex(item => item.toString().includes(telephone));
    if (index >= 0) {
      let _errors = [...formValidationState.telephone]
      _errors.splice(index, 1)
      setFormValidationState((formValidationState) => ({ ...formValidationState, telephone: _errors }))
    }
  }

  const rowClassName = (row) => {
    if (!row.valid) {
      return "invalid-row-color"
    }
  }

  return (
    <div className="datatable-crud-demo">
      <Toast ref={toast} />

      <div className="card">
        <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

        <DataTable ref={dt} value={customers} selection={selectedCustomers} onSelectionChange={(e) => setSelectedCustomers(e.value)}
          dataKey="customerNr" paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} customers"
          sortField={"valid"} sortOrder={1} size="small" autoLayout={true}
          rowClassName={(e) => rowClassName(e)}
          globalFilter={globalFilter} header={header} responsiveLayout="scroll" csvSeparator=";">
          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
          <Column field="customerNr" header="CustomerNr" sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="customerId" hidden="true" header="Customer Id" exportable={false} sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="primaryEmail" header="PrimaryEmail" sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="secondaryEmail" header="SecondaryEmail" body={listBodyTemplate} sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="organization" hidden={!isAdmin} header="Organization" sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="company" header="Company" sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="company2" header="Company2" sortable body={listBodyTemplate} style={{ minWidth: '1rem' }}></Column>
          <Column field="country" header="Country" sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="language" header="Language" sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="telephone" header="Telephone" sortable body={listBodyTemplate} style={{ minWidth: '1rem' }}></Column>
          <Column field="firstName" header="FirstName" sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="surName" header="SurName" sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="pkwData" header="PKWData" sortable style={{ minWidth: '1rem' }} body={booleanBodyTemplate}></Column>
          <Column field="lkwData" header="LKWData" sortable style={{ minWidth: '1rem' }} body={booleanBodyTemplate}></Column>
          <Column field="createdAt" header="CreatedAt" hidden exportable={false} sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="updatedAt" header="UpdatedAt" hidden exportable={false} sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="updatedBy" header="UpdatedBy" exportable={false} hidden sortable style={{ minWidth: '1rem' }}></Column>
          <Column field="valid" header="Valid?" hidden exportable={false} body={validationBodyTemplate} sortable style={{ minWidth: '1rem' }}></Column>

          <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
        </DataTable>
      </div>

      <Dialog visible={customerDialog} style={{ width: '450px' }} header="Customer Details" modal className="p-fluid" footer={customerDialogFooter} onHide={hideDialog}>
        <div className="field">
          <label htmlFor="customerNr">CustomerNr</label>
          <InputText id="customerNr" value={customer.customerNr} onKeyUp={(e) => validateCustomerNr(customer.customerNr)} onChange={(e) => onInputChange(e, 'customerNr')} required autoFocus className={classNames({ 'p-invalid': formValidationState.customerNr })} />
          {formValidationState.customerNr && <small className="p-error">{formValidationState.customerNr}</small>}
        </div>
        <div className="field">
          <label htmlFor="primaryEmail">PrimaryEmail</label>
          <InputText id="primaryEmail" value={customer.primaryEmail} onKeyUp={(e) => validatePrimaryEmail(customer)} onChange={(e) => onInputChange(e, 'primaryEmail')} required autoFocus className={classNames({ 'p-invalid': formValidationState.primaryEmail })} />
          {formValidationState.primaryEmail && <small className="p-error">{formValidationState.primaryEmail}</small>}
        </div>
        <div className="field">
          <label htmlFor="secondaryEmail">SecondaryEmail</label>
          <Chips id="secondaryEmail" addOnBlur={true} allowDuplicate={false} value={customer.secondaryEmail} onAdd={(e) => onSecondaryEmailAdd(e, customer)} onRemove={(e) => onSecondaryEmailRemove(e.value)} onChange={(e) => onInputChange(e, 'secondaryEmail')} separator="," required autoFocus className={classNames({ 'p-invalid': formValidationState.secondaryEmail.length > 0 })} />
          {formValidationState.secondaryEmail.length > 0 && <small className="p-error">{formValidationState.secondaryEmail.toString()}</small>}
        </div>
        <div className="field">
          <label htmlFor="company">Company</label>
          <InputText id="company" value={customer.company} onKeyUp={(e) => validateCompany(customer.company)} onChange={(e) => onInputChange(e, 'company')} required autoFocus className={classNames({ 'p-invalid': formValidationState.company })} />
          {formValidationState.company && <small className="p-error">{formValidationState.company}</small>}
        </div>
        <div className="field">
          <label htmlFor="company2">Company2</label>
          <Chips id="company2" addOnBlur={true} allowDuplicate={false} value={customer.company2} onAdd={(e) => onCompany2Add(e)} onRemove={(e) => onCompany2Remove(e)} onChange={(e) => onInputChange(e, 'company2')} separator="," autoFocus className={classNames({ 'p-invalid': formValidationState.company2.length > 0 })} />
          {formValidationState.company2.length > 0 && <small className="p-error">{formValidationState.company2.toString()}</small>}
        </div>
        <div className="field">
          <label htmlFor="country">Country</label>
          <InputText id="country" value={customer.country} onLoad={(e) => validateCountry(customer.country)} onKeyUp={(e) => validateCountry(customer.country)} onChange={(e) => onInputChange(e, 'country')} required autoFocus className={classNames({ 'p-invalid': formValidationState.country })} />
          {formValidationState.country && <small className="p-error">{formValidationState.country}</small>}
        </div>
        <div className="field">
          <label htmlFor="language">Language</label>
          <InputText id="language" value={customer.language} onKeyUp={(e) => validateLanguage(customer.language)} onChange={(e) => onInputChange(e, 'language')} required autoFocus className={classNames({ 'p-invalid': formValidationState.language })} />
          {formValidationState.language && <small className="p-error">{formValidationState.language}</small>}
        </div>
        <div className="field">
          <label htmlFor="telephone">Telephone</label>
          <Chips id="telephone" addOnBlur={true} allowDuplicate={false} value={customer.telephone} onAdd={(e) => onTelephoneAdd(e)} onRemove={(e) => onTelephoneRemove(e)} onChange={(e) => onInputChange(e, 'telephone')} required autoFocus className={classNames({ 'p-invalid': formValidationState.telephone.length > 0 })} />
          {formValidationState.telephone.length > 0 && <small className="p-error">{formValidationState.telephone.toString()}</small>}
        </div>
        <div className="field">
          <label htmlFor="firstName">FirstName</label>
          <InputText id="firstName" value={customer.firstName} onKeyUp={(e) => validateFirstName(customer.firstName)} onChange={(e) => onInputChange(e, 'firstName')} autoFocus className={classNames({ 'p-invalid': formValidationState.firstName })} />
          {formValidationState.firstName && <small className="p-error">{formValidationState.firstName}</small>}
        </div>
        <div className="field">
          <label htmlFor="surName">SurName</label>
          <InputText id="surName" value={customer.surName} onKeyUp={(e) => validateSurName(customer.surName)} onChange={(e) => onInputChange(e, 'surName')} required autoFocus className={classNames({ 'p-invalid': formValidationState.surName })} />
          {formValidationState.surName && <small className="p-error">{formValidationState.surName}</small>}
        </div>
        <div className="field">
          <label htmlFor="pkwData">PKWData</label>
          <InputSwitch id="pkwData" checked={customer.pkwData} onChange={(e) => onInputBooleanChange(e, 'pkwData')} autoFocus />
        </div>
        <div className="field">
          <label htmlFor="lkwData">LKWData</label>
          <InputSwitch id="lkwData" checked={customer.lkwData} onChange={(e) => onInputBooleanChange(e, 'lkwData')} autoFocus />
        </div>
      </Dialog>

      <Dialog visible={deleteCustomerDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteCustomerDialogFooter} onHide={hideDeleteCustomerDialog}>
        <div className="confirmation-content">
          <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
          {customer && <span>Are you sure you want to delete <b>{customer.name}</b>?</span>}
        </div>
      </Dialog>

      <Dialog visible={deleteCustomersDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteCustomersDialogFooter} onHide={hideDeleteCustomersDialog}>
        <div className="confirmation-content">
          <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
          {customer && <span>Are you sure you want to delete the selected customers?</span>}
        </div>
      </Dialog>

      <Dialog visible={progressBar} header={progressHeader} style={{ width: '450px' }} modal >
        <ProgressBar value={progress} showValue={false} max={progressBarMax} />
      </Dialog>
    </div>
  );

}

export default Customers
